import { io, type Socket } from 'socket.io-client'
import type { App } from 'vue'
const { VITE_API_BASE_URL } = import.meta.env

// 定义 Socket.io 实例的类型
declare module '@vue/runtime-core' {
  interface ComponentCustomProperties {
    $socket: Socket
  }
}

// 创建 Socket.io 实例
const socket: Socket = io(VITE_API_BASE_URL, {
  transports: ['polling'], // 'websocket'
  path: '/v4/socket.io',
  autoConnect: false, // 自动连接
  reconnection: true, // 启用重连机制
  reconnectionAttempts: 4, // 最大重连次数
  reconnectionDelay: 2000, // 重连间隔，单位毫秒
  reconnectionDelayMax: 10000, // 最大重连间隔
  timeout: 10000, // 连接超时
})

// 定义插件
const socketPlugin = {
  install(app: App) {
    // 将 Socket.io 实例挂载到全局属性
    app.config.globalProperties.$socket = socket
  },
}

export default socketPlugin
